import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell, User, LogOut, ChevronDown, Shield, RefreshCw } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useNotifications } from '../../contexts/NotificationContext';
import { getInitials } from '../../utils/helpers';

const Header = ({ onNotificationClick }) => {
  const { user, logout, restoreAdmin } = useAuth();
  const { unreadCount } = useNotifications();
  const navigate = useNavigate();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const handleRestoreAdmin = async () => {
    await restoreAdmin();
    navigate('/admin');
  };

  const isSwitchedUser = user?.role !== 'admin' && localStorage.getItem('eureka_original_admin');

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-40">
      <div className="flex items-center justify-between px-6 py-3">
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-primary-700 rounded-lg flex items-center justify-center">
            <Shield className="text-white w-5 h-5" />
          </div>
          <div>
            <h1 className="text-lg font-bold text-gray-900">RD Garantía</h1>
          </div>
        </div>

        <div className="flex items-center space-x-3">
          {isSwitchedUser && (
            <div className="flex items-center space-x-2 px-3 py-1.5 bg-warning-50 border border-warning-200 rounded-lg">
              <RefreshCw className="w-3.5 h-3.5 text-warning-600" />
              <span className="text-sm text-warning-800 font-medium">
                Modo: {user?.role.replace('_', ' ')}
              </span>
              <button
                onClick={handleRestoreAdmin}
                className="ml-2 px-2 py-0.5 text-xs bg-warning-600 text-white rounded hover:bg-warning-700 transition-colors"
              >
                Volver Admin
              </button>
            </div>
          )}

          <button
            onClick={onNotificationClick}
            className="relative p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <Bell className="w-5 h-5" />
            {unreadCount > 0 && (
              <span className="absolute -top-0.5 -right-0.5 inline-flex items-center justify-center w-5 h-5 text-xs font-medium text-white bg-danger-500 rounded-full">
                {unreadCount > 9 ? '9+' : unreadCount}
              </span>
            )}
          </button>

          <div className="relative">
            <button
              onClick={() => setShowUserMenu(!showUserMenu)}
              className="flex items-center space-x-2 p-1.5 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <div className="w-8 h-8 bg-primary-600 rounded-full flex items-center justify-center">
                <span className="text-white font-medium text-sm">
                  {getInitials(user?.nombre)}
                </span>
              </div>
              <div className="text-left hidden md:block">
                <p className="text-sm font-medium text-gray-900">{user?.nombre}</p>
                <p className="text-xs text-gray-500 capitalize">{user?.role}</p>
              </div>
              <ChevronDown className="w-4 h-4 text-gray-400" />
            </button>

            {showUserMenu && (
              <>
                <div
                  className="fixed inset-0 z-10"
                  onClick={() => setShowUserMenu(false)}
                ></div>
                <div className="absolute right-0 mt-1 w-56 bg-white rounded-lg shadow-strong border border-gray-200 py-1 z-20 animate-fade-in">
                  <div className="px-4 py-3 border-b border-gray-100">
                    <p className="text-sm font-medium text-gray-900">{user?.nombre}</p>
                    <p className="text-xs text-gray-500">{user?.email}</p>
                  </div>
                  {isSwitchedUser && (
                    <button
                      onClick={() => {
                        setShowUserMenu(false);
                        handleRestoreAdmin();
                      }}
                      className="w-full flex items-center px-4 py-2 text-sm text-warning-700 hover:bg-warning-50 transition-colors"
                    >
                      <RefreshCw className="w-4 h-4 mr-3" />
                      Volver a Admin
                    </button>
                  )}
                  <button
                    onClick={() => {
                      setShowUserMenu(false);
                      navigate('/perfil');
                    }}
                    className="w-full flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                  >
                    <User className="w-4 h-4 mr-3" />
                    Mi Perfil
                  </button>
                  <button
                    onClick={handleLogout}
                    className="w-full flex items-center px-4 py-2 text-sm text-danger-600 hover:bg-danger-50 transition-colors"
                  >
                    <LogOut className="w-4 h-4 mr-3" />
                    Cerrar Sesión
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
